import React from 'react';
import GroupInfo from './modules/GroupInfo';
import GroupText from './modules/GroupText';
import FAQ from './modules/FAQ';
import Danmaku from './modules/Danmaku';
import BottomButton from './modules/BottomButton';
import SingleImage from './modules/SingleImage';
import RichText from './modules/RichText';
import HotspotImage from './modules/HotspotImage';

const ModuleRenderer = ({ type, data, onEdit, moduleId, style, onStyleChange }) => {
    switch (type) {
        case 'GROUP_INFO':
            return <GroupInfo data={data} onEdit={() => onEdit({ id: moduleId, type, data })} style={style} />;
        case 'GROUP_TEXT':
            return <GroupText data={data} onEdit={() => onEdit({ id: moduleId, type, data })} style={data.style} />;
        case 'FAQ':
            return <FAQ data={data} onEdit={() => onEdit({ id: moduleId, type, data })} style={style} onChange={onStyleChange} />;
        case 'DANMAKU':
            return <Danmaku data={data} onEdit={() => onEdit({ id: moduleId, type, data })} />;
        case 'BOTTOM_BUTTON':
            return <BottomButton data={data} onEdit={() => onEdit({ id: moduleId, type, data })} style={style} />;
        case 'SINGLE_IMAGE':
            return <SingleImage data={data} onEdit={() => onEdit({ id: moduleId, type, data })} />;
        case 'RICH_TEXT':
            return <RichText data={data} onEdit={() => onEdit({ id: moduleId, type, data })} />;
        case 'HOTSPOT_IMAGE':
            return <HotspotImage data={data} onEdit={() => onEdit({ id: moduleId, type, data })} />;
        default:
            return null;
    }
};

export default ModuleRenderer;